import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';

import { AppState } from 'store';
import { BasketModal } from 'components';
import { generateDispatchToPropsMap, goToExternalUrl } from 'helpers';
import { setShowSessionHasExpiredWarning, SetShowSessionHasExpiredWarningFunc, removeUserInfo, RemoveUserInfoFunc } from 'store/basket/actions';
import { routes } from 'routes';

const SESSION_HAS_EXPIRED_TITLE = 'Sorry, your session has expired. If you were logged in, please re-log in to continue with the purchase process.';

interface OwnProps {
    children?: React.ReactNode;
}

interface StateProps {
    shouldShowSessionHasExpiredWarning: boolean;
}

interface DispatchProps {
    setShowSessionHasExpiredWarning: SetShowSessionHasExpiredWarningFunc;
    removeUserInfo: RemoveUserInfoFunc;
}

class BasketRoot extends Component<StateProps & OwnProps & DispatchProps> {
    handleSessionHasExpiredModalClick = () => {
        this.props.setShowSessionHasExpiredWarning(false);
        this.props.removeUserInfo();
        goToExternalUrl(routes.basket.path);
    };

    render(): JSX.Element {
        const { children, shouldShowSessionHasExpiredWarning } = this.props;

        return (
            <>
                {children}
                <BasketModal open={shouldShowSessionHasExpiredWarning} title={SESSION_HAS_EXPIRED_TITLE} onClick={this.handleSessionHasExpiredModalClick} />
            </>
        );
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        shouldShowSessionHasExpiredWarning: state.basketState.shouldShowSessionHasExpiredWarning
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [setShowSessionHasExpiredWarning, removeUserInfo]);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketRoot);